import React from 'react';
import * as actions from '../store/actions/index';
import { connect } from 'react-redux';
import PeopleSwiper from '../components/PeopleSwiper/PeopleSwiper';
import TittleOverview from '../components/TittleOverview/TittleOverview';
import HeroTitle from '../components/HeroTitle/HeroTitle';
import TrailersSwiper from '../components/TrailersSwiper/TrailersSwiper';
import Reviews from '../components/Reviews/Reviews';
import './TitleContainer.scss';

class TitleContainer extends React.PureComponent {
  componentDidMount() {
    this.loadTitleInfo();
  }

  loadTitleInfo = () => {
    const { type, id } = this.props.match.params;
    this.props.onFetchTitleInfo(type, id);
  };

  backHandler = () => {
    this.props.history.goBack();
  };

  render() {
    const { details, cast, trailers, reviews } = this.props;

    return (
      <div className="title-page-container">
        <HeroTitle {...details} backTo={this.backHandler} />
        <div className="main-content">
          <TittleOverview {...details}>OverView</TittleOverview>
          <PeopleSwiper sources={cast} />
          <TrailersSwiper sources={trailers} />
          <Reviews reviews={reviews} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  details: state.titileInfoReducer.details,
  trailers: state.titileInfoReducer.trailers,
  cast: state.titileInfoReducer.cast,
  reviews: state.titileInfoReducer.reviews,
  loading: state.titileInfoReducer.loading
});

const mapDispatchToProps = dispatch => ({
  onFetchTitleInfo: (type, id) => dispatch(actions.fetchTitleInfo(type, id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TitleContainer);
